module.exports = __webpack_public_path__ + "img/white.420a7bff.png";